import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { rightArrowGreen } from '../../../assets/images';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Categories = () => {
  const { t } = useTranslation();

     useEffect(() => {
        AOS.init({ duration: 2000, once: false }); 
      }, []);

  const cards = [
    {
      id: 1,
      title: 'Peşəkar İqlim və Havalandırma Həlləri',
      description: 'Yaşayış və iş məkanlarınız üçün mərkəzi kondisioner və havalandırma sistemləri ilə ideal iqlim şəraitini təmin edirik. VRF kondisioner sistemləri, çiller və fankoyl həlləri sayəsində enerji səmərəliliyi və maksimum komfort təqdim edirik.',
      width: '23%',
    },
    {
      id: 2,
      title: 'İstilik və Su Filtrasiya Sistemləri',
      description: 'Mərkəzi istilik sistemləri, su yumşaldıcılar və filtrasiya avadanlıqları ilə daha sağlam və təhlükəsiz mühit yaradın. Su keyfiyyətini artıran həllərimiz və effektiv istilik sistemlərimiz hər mövsüm rahatlığınızı təmin edəcək.',
      width: '23%',
    },
    {
      id: 3,
      title: 'Layihələndirmə, Quraşdırma və Servis',
      description: 'Mütəxəssislərimiz tərəfindən obyektinizə uyğun mühəndis həlləri, peşəkar quraşdırma və uzunmüddətli servis xidməti təqdim edirik. Hər bir sistemin etibarlı və effektiv işləməsi üçün tam dəstək və texniki xidmət göstəririk.',
      width: '50%',
    }
  ];

  return (
    <div data-aos="fade-up" className='mt-[88px] md:mt-[104px]'>
      <div className='max-w-containerSm md:max-w-container mx-auto'>
        <div className='gap-5 flex-wrap hidden md:flex'>
          {cards.map((card) => (
            <div
              key={card.id}
              className='bg-white py-5 px-6 border border-[#E5E5E5] rounded-[12px]' 
              style={{ width: card.width, height: "246px" }}
            >
              <p className='text-[#1C1C1C] font-medium text-[24px] line-clamp-2 max-w-[300px]'>{card.title}</p>
              <p className='mt-3 text-[#1C1C1C] line-clamp-3 h-[75px]'>
  {card.description}
</p>

              <a href={`/services/${card.id}`}>  
                <div className='flex items-center justify-end mt-2'>
                  <img className='w-[44px]' src={rightArrowGreen} alt="arrow" />
                </div>
              </a>
            </div>
          ))}
        </div>
        
        <div className='flex flex-col gap-5 md:hidden w-full'>
          {cards.map((card) => (
            <div
              key={card.id}
              className='bg-white py-5 px-6 border border-[#E5E5E5] rounded-[12px]' 
              style={{ width: "full", height: "280px" }}
            >
              <p className='text-[#1C1C1C] font-medium text-[24px] line-clamp-2 max-w-[300px]'>{card.title}</p>
              <p className='mt-3 text-[#1C1C1C] line-clamp-4 h-[100px]'>
  {card.description}
</p>

              <a href={`/services/${card.id}`}>  
                <div className='flex items-center justify-end mt-2'>
                  <img className='w-[44px]' src={rightArrowGreen} alt="arrow" />
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Categories
